import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../utils/api';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [courseId, setCourseId] = useState(null);
  const [courseTitle, setCourseTitle] = useState('');

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }

    const sessionId = searchParams.get('session_id');
    if (!sessionId) {
      setStatus('error');
      return;
    }

    const verify = async () => {
      try {
        const res = await api.post('/payments/verify', { session_id: sessionId });
        if (res.data.success) {
          setCourseId(res.data.course_id);
          setCourseTitle(res.data.course_title || 'your course');
          setStatus('success');
        } else {
          setStatus('error');
        }
      } catch (err) {
        // If already verified (duplicate call), treat as success
        if (err.response?.status === 400 && err.response?.data?.course_id) {
          setCourseId(err.response.data.course_id);
          setCourseTitle(err.response.data.course_title || 'your course');
          setStatus('success');
        } else {
          setStatus('error');
        }
      }
    };

    verify();
  }, [searchParams, user, navigate]);

  if (status === 'verifying') {
    return (
      <div className="page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <div style={{ textAlign: 'center' }}>
          <div className="loading-spinner" style={{ fontSize: '2rem', marginBottom: '1rem' }}>⏳</div>
          <p>Confirming your payment...</p>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <div style={{ textAlign: 'center', maxWidth: '480px', padding: '2rem' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>❌</div>
          <h2>Payment Verification Failed</h2>
          <p style={{ color: 'var(--text-muted)', marginBottom: '1.5rem' }}>
            We could not confirm your payment. If you were charged, please contact support — your enrollment will be processed manually.
          </p>
          <Link to="/courses" className="btn-primary">Browse Courses</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <div style={{ textAlign: 'center', maxWidth: '540px', padding: '2rem' }}>
        <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🎉</div>
        <h1 style={{ marginBottom: '0.5rem' }}>Payment Successful!</h1>
        <p style={{ color: 'var(--text-muted)', marginBottom: '2rem', fontSize: '1.1rem' }}>
          You're now enrolled in <strong>{courseTitle}</strong>. Start learning right away!
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          {courseId && (
            <Link to={`/courses/${courseId}`} className="btn-primary">
              Go to Course
            </Link>
          )}
          <Link to="/my-courses" className="btn-secondary">
            My Courses
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
